<script>
    import Container from '@services/Container';
    import CreateAdversaryForm from './../../csp-app/views/record/form/CreateAdversaryForm.vue';
    import CreateInsurancePolicyForm from '../../csp-app/views/record/form/CreateInsurancePolicyForm';
    import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';
    import RecordNewSkeletton from '@csp-app/lib/damage/record/create/RecordNewSkeletton';
    import GenderEnum from '@js/enums/GenderEnum';

    const container = Container.getInstance();
    const flashMessenger = container.getFlashMessenger();
    const loginStatus = container.getLoginStatusStore();
    const recordRepository = container.getRecordRepository();
    const firmRepository = container.getFirmRepository();

    export default {
        components: {
            'csp-create-adversary-form': CreateAdversaryForm,
            'csp-create-insurance-policy-form': CreateInsurancePolicyForm,
        },
        data() {
            const recordNewSkeletton = new RecordNewSkeletton();
            return {
                currentUser: null,
                currentFirm: null,
                firmOptions: [],
                isCreating: false,
                isLoadingCurrentFirm: true,
                isLoadingFirms: true,
                isLoadingFirmData: false,
                recordAttributes: recordNewSkeletton.data.attributes,
                recordForm: new RecordCreateForm(recordNewSkeletton.data.attributes),
                selectedFirm: null,
            }
        },
        computed: {
            hasSwitchableFirms() {
                return this.firmOptions.length > 1
            },
            isCasualtyClaimTypeSelected() {
                return this.recordForm.isCasualtyClaimTypeSelected();
            },
            isComprehensiveClaimTypeSelected() {
                return this.recordForm.isComprehensiveClaimTypeSelected();
            },
            isDeliveryClaimTypeSelected() {
                return this.recordForm.isDeliveryClaimTypeSelected();
            },
            shouldShowMissingFirmsWarning() {
                if (this.isLoadingFirms || this.isLoadingCurrentFirm) {
                    return false;
                }
                return this.firmOptions.length === 0;
            },
        },
        watch: {
            isLoadingFirmData(newValue) {
                this.recordForm.setReadOnly(newValue);
            },
            'recordAttributes.firmId'() {
                this.loadSelectedFirmData();
            },
            'recordAttributes.minimalRecordCreation'(newValue) {
                if (newValue) {
                    this.recordForm.minimalRecordCreationEnable();
                    return;
                }

                this.recordForm.minimalRecordCreationDisable();
            },
            'recordAttributes.customer.data.attributes.gender'(newValue) {
                if (newValue !== GenderEnum.COMPANY) {
                    this.recordAttributes.customer.data.attributes.isCustomerDeductingVatEntitled = 'no';
                    return;
                }

                this.recordAttributes.customer.data.attributes.isCustomerDeductingVatEntitled = 'yes';
            },
        },
        mounted() {
            this.loadCurrentFirm();
            this.loadFirmOptions();
            this.currentUser = loginStatus.getCurrentUserAttributes();
        },
        methods: {
            loadCurrentFirm() {
                firmRepository.showCurrent().then(currentFirm => {
                    this.currentFirm = currentFirm.data.attributes
                    this.isLoadingCurrentFirm = false;
                })
            },
            initFirmData() {
                // Overwrite in concrete component!
            },
            loadFirmOptions() {
                firmRepository.getDropdownOptionsForRecordCreation().then((options) => {
                    this.firmOptions = options;

                    if (this.firmOptions.length === 1) {
                        this.recordAttributes.firmId = this.firmOptions[0].value;
                    }

                    this.isLoadingFirms = false;
                });
            },
            loadSelectedFirmData() {
                if (!this.recordAttributes.firmId) {
                    return;
                }

                this.isLoadingFirmData = true;

                firmRepository.showForRecordCreate(this.recordAttributes.firmId).then(firm => {
                    this.recordForm.setFirmPermissions(firm.data.meta.permissions);

                    this.initFirmData(firm);

                    this.isLoadingFirmData = false;
                });
            },
            stateClasses(selectorRegex) {
                if (!this.recordForm.hasValidationResult()) {
                    return [];
                }
                const classes = ['state'];
                const hasErrors = this.recordForm.hasErrorsForRegex(new RegExp(selectorRegex));
                classes.push(hasErrors ? 'state-invalid' : 'state-valid');
                return classes;
            },
            submit() {
                if (this.isCreating) {
                    return;
                }

                this.isCreating = true;
                recordRepository.createRecord({data: {attributes: this.recordForm.getData()}})
                    .then(
                        (response) => {
                            this.recordForm.clearValidationErrors();
                            this.$router.push({name: 'record-create-success', params: {recordId: response.data.id}});
                            this.isCreating = false;
                        },
                        (error) => {
                            this.isCreating = false;
                            if (this.recordForm.setValidationErrors(error)) {
                                return;
                            }
                            flashMessenger.addError('Fehler beim Anlegen der Schadenakte: ' + error.getStatusText())
                        }
                    );
            },
        },
    }
</script>
